import { render, staticRenderFns } from "./EndowmentsUploadDialog.vue?vue&type=template&id=05465b1e&scoped=true"
import script from "./EndowmentsUploadDialog.vue?vue&type=script&lang=js"
export * from "./EndowmentsUploadDialog.vue?vue&type=script&lang=js"
import style0 from "./EndowmentsUploadDialog.vue?vue&type=style&index=0&id=05465b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05465b1e",
  null
  
)

export default component.exports